module.exports = "/_next/static/images/loading_09-25636080368cb5554d8fa6f9e2d5e6d4.png";